import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { authAPI, apiHelpers } from '../api/api';
import '../css/Login.css';

const Login = ({ onForgotPassword, onSwitchToRegister }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    
    try {
      const userData = await authAPI.login({ email, password });
      toast.success('Sikeres bejelentkezés!');
      setTimeout(() => navigate('/'), 1200);
    } catch (error) {
      toast.error(apiHelpers.handleApiError(error));
    }
  };

  return (
    <form className="login-form" onSubmit={handleLogin}>
      <h2>Bejelentkezés</h2>
      <label htmlFor="email">Email</label>
      <input
        type="email"
        placeholder="Email cím..."
        value={email}
        onChange={e => setEmail(e.target.value)}
        required
      />
      <label htmlFor="password">Jelszó</label>
      <input
        type="password"
        placeholder="Jelszó..."
        value={password}
        onChange={e => setPassword(e.target.value)}
        required
      />
      <div className="login-remember-me">
        <input type="checkbox" id="rememberMe" />
        <label htmlFor="rememberMe">Emlékezz rám</label>
      </div>
      <div className="login-forgot-password">
        <span onClick={onForgotPassword}>Elfelejtetted a jelszavad?</span>
      </div>
      <button type="submit">Bejelentkezés</button>
      <div className="login-register-link">
        Nincs még fiókja?
        <span onClick={onSwitchToRegister}>Regisztráció</span>
      </div>
    </form>
  );
};

export default Login;